/* eslint-disable jsx-a11y/anchor-is-valid */
import { faPlus, faFilter, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppContext, usePersistedState } from "../../AppContext";
import func, { removePropertiesRecursive, validateInvoice } from "../../services/functions";
import mainAxios from "../../services/mainAxios";
import InvoiceStatus from "../Invoice/columns/InvoiceStatus";
import Loader from "../Layout/Loader";
import UploadInvoice from "../Invoice/UploadInvoice";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import generateCustomInvoiceColumns from "./generateCustomInvoiceColumns";
import invoiceActions from "../../services/invoiceActions.json";
import invoiceStatuses from "../../services/invoiceStatuses.json";
import invoiceTypes from "../../services/InvoiceTypes.json";
import ThermalPrinterInvoiceContent from "./ThermalPrinterInvoiceContent";
import Swal from "sweetalert2";
import selectStyle from "../../design/selectStyle";
import generatePosColumns from "../MyPos/components/generatePosColumns";
import DateRange from "../global/DateRange";
import AlertCertificate from "../global/AlertCertificate";
import AlertSubscription from "../global/AlertSubscription";
import PrimeTable, { parseFilterParams } from "../PrimeTable/PrimeTable";
import { Column } from "primereact/column";
import ExportCsvPrime from "../global/ExportCsvPrime";
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from "primereact/dialog";
import {  globalFilterStatisticCard } from "../global/StatisticsCards";
import { defaultTableRows } from "../../services/data";
import useShowInvoicePdf from "../global/useShowInvoicePdf";
import ExportCsvMultiple from "../global/ExporCsvMultiple";
import { duplicateInvoice } from "./Utils";


const moment = require("moment");

const CustomInvoicesNew = (props) => {
    const { t,i18n } = useTranslation("translations");
    const {
        user: [user],
        selectedCompany: [selectedCompany],
        company: [fullCompany],
        dates: [dates, setDates],
        refreshStatuses
    } = useAppContext();
    const { history, isPos,invoiceStore } = props;

    const company = user.companiesRights.find(
        (company) => company.id === parseInt(selectedCompany)
    );

    const {
        filters,
        setFilters,
        defaultFilters,
        persistedData,
        setPersistedData,
        businessUnitCodes,
    } = invoiceStore


    const [persistedRowPerPage, setPersistedRowPerPage,] = usePersistedState(
        10,
        "rowsPerPage"
    );
      


    const [expandedData, setExpandedData] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [loadingExpandData, setLoadingExpandData] = useState(false);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedDeleteRows, setSelectedDeleteRows] = useState([]);
    const [filtersCollapsed, setFiltersCollapsed] = usePersistedState(false, "customInvoicesFiltersCollapsed")
    const filterCount = useMemo(() => {
        let count = 0;
        const params = filters?.params;
        if (defaultFilters && params) {
            Object.keys(params).forEach(key => {
                const value = params[key];
                const isDefault = JSON.stringify(value) === JSON.stringify(defaultFilters?.params?.[key]);
                if (!isDefault && value != null) {
                    Array.isArray(value) ? count += value.length : count++;
                }
            });
        }
        return count;
    }, [defaultFilters, filters]);
    const [actionLoading, setActionLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [spinLoading, setSpinLoading] = useState(false)


    const uIOptions = [
        { value: "eic", label: "EIC" },
        { value: "internalId", label: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? "ERP ID" },
        { value: "iic", label: "IIC" },
        { value: "number", label: "UBLID" },
        { value: "param1", label: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId1")?.value ?? (t("pos.additional") + " 1") },
        { value: "param2", label: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "AdditionalId2")?.value ?? (t("pos.additional") + " 2") },
    ];
   
    const myinvoiceTypes = [
        { value:"badDebt",label:t("books.badDebt") },
        { value:"reverse",label:t("books.reverse") },
        { value:"selfInvoice",label: t("invoice.selfInvoice")},
        { value:"summary",label:t("invoice.summaryInvoice")}
      ]
      

    const [invoices, setInvoices] = React.useState(null);
    const [invoicesForCSV, setInvoicesForCSV] = useState([]);
    const [loading, setLoading] = React.useState(false);
    const [uIType, setUIType] = useState({
        value: "internalId",
        label: fullCompany?.companyAttributes?.find(a => a?.attribute?.param == "internalId")?.value ?? "ERP ID",
        uidValue: null,
    });

    const [statistics, setStatistics] = useState(null);
    const [openUploadInvoice, setOpenUploadInvoice] = useState(false);
    const [currentInvoiceIndex, setCurrentInvoiceIndex] = React.useState(null);


    const defaultSortCriteria={
        field: "issueDate",
        direction: "DESC"
    }

    const [tableRows, setTableRows] = useState({
        ...defaultTableRows,
        rowsPerPage:persistedRowPerPage,
        sortCriteria:defaultSortCriteria
    });

  const { showInvoicePdf,pdfEmbed,loadingPdf } = useShowInvoicePdf()



    React.useEffect(() => {
        getFilteredResults({data:filters});
    }, [selectedCompany, refresh]);

    
    const getDataFromInvoiceRequest = (invoice) => {
        return mainAxios.post("apiEndpoint/search", {
             object: "GetCustomInvoice",
             params: {
                 id: String(invoice?.id)
             }
         }).then(res => {
             if (res?.data?.status) {
                const parsedInvoice = func.parseCustomInvoiceResponse(
                    res.data.content[0]
                  );
                    return parsedInvoice
             }
             return null
         }).catch((error)=>{
           return null
         })
     }


    const handleDuplicateInvoice = async (e,invoice) => {
        e.preventDefault()
        setSpinLoading(true)
        const newState = await getDataFromInvoiceRequest(invoice)
        if(!newState) return
        const validateInvoiceFields = validateInvoice({ setErrors, toast, state: newState });
        if (!validateInvoiceFields) return;
        setSpinLoading(true)
        await duplicateInvoice({ invoice:newState,company,t,user,onSuccess:(res)=>{
            props.history.push("/edit-invoice/" + res.data.content[0].id);
        }});
        setSpinLoading(false)
      };


    const getFilteredResults = ({
        data,
        pageSize = (persistedRowPerPage?? defaultTableRows.rowsPerPage),
        page = defaultTableRows.currentPage,
        clearFilters = false,
        getInvoicesForCVS = false,
        sortCriteria = [ defaultSortCriteria ]
    }) => {
        let requestFilters = data ? data : filters;
        if (!getInvoicesForCVS) setLoading(true);
        if (invoicesForCSV.length > 0) setInvoicesForCSV([]);
        if (uIType?.uidValue && !clearFilters) {
            let val;
            val = uIType.uidValue;
            requestFilters.params = {
                ...requestFilters.params,
                [uIType.value]: val,
            };
        }
        requestFilters= parseFilterParams({filters:requestFilters,columns})

        let params={
            ...requestFilters.params,
            type: requestFilters.params.type.join(",") || null,
            internalId: requestFilters.params.internalId
                ? requestFilters.params.internalId + "<L>"
                : null,
            name: requestFilters.params.name
                ? requestFilters.params.name + "<L>"
                : null,
            recordUser: requestFilters.params.recordUser
                ? requestFilters.params.recordUser + "<L>"
                : null,
            profileId: requestFilters.params.profileId?.join(",") || null,
            statusObj: requestFilters.params.statusObj?.join(",") || null,
            currency: requestFilters.params.currency?.join(",") || null,
            param1: requestFilters.params.param1
                ? requestFilters.params.param1 + "<L>"
                : null,
            param2: requestFilters.params.param2
                ? requestFilters.params.param2 + "<L>"
                : null,
        }

        if(getInvoicesForCVS){
            const {isDeleted, param1, param2,...restParams } = params
            params=restParams
        }


        return mainAxios
            .post("apiEndpoint/search", {
                object:getInvoicesForCVS?"CustomInvoiceResponseNewV" : "GetCustomInvoiceV",
                ...requestFilters,
                params,
                pagination: getInvoicesForCVS
                    ? null
                    : {
                        pageSize,
                        pageNumber: page,
                    },
                    sortCriteria
            })
            .then((res) => {
                if (res?.data?.status === true) {
                    if (getInvoicesForCVS) {
                        setInvoicesForCSV(res.data.content);
                    } else {
                        setInvoices(
                            res.data.content
                                .map((invoice) => {
                                    return func.parseCustomInvoiceResponse(invoice);
                                })
                                .map((invoice) => ({
                                    ...invoice,
                                    invoiceHistorics: invoice.invoiceHistorics?.sort(
                                        (a, b) => b.recordDate - a.recordDate
                                    ),
                                }))
                        );
                        setTableRows((tableRows)=>({
                            ...tableRows,
                            totalRows: res?.data?.totalSize,
                        }));
                    }
                    if (!getInvoicesForCVS) setLoading(false);
                    return true;
                } else {
                    setInvoices([]);
                    if (!getInvoicesForCVS) setLoading(false);
                    return false;
                }
            })
            .catch((err) => {
                setLoading(false);
                return false;
            });
    };



    const handleParamsChange = (e, label, val) => {
        const key = e ? e.target.name : label;
        const value = e ? e.target.value : val;
        if (uIOptions?.map((op) => op.value).includes(key)) {
            setUIType({
                value: key,
                label: uIOptions?.find((op) => op.value == key)?.label,
                uidValue: value,
            });
        } else {
            setFilters((filters) => ({
                ...filters,
                params: {
                    ...filters.params,
                    [key]: value,
                },
            }));
        }
    };

    const toggleDeleteInvoice = (e, invoice) => {
        e.preventDefault();
        setSelectedDeleteRows((state)=>{
            const _state=[...state]
            const checkedValueIndex =_state.findIndex(sRow=>sRow.id==invoice?.id)
            if(checkedValueIndex>=0) {
                _state.splice(checkedValueIndex,1)
                return _state
            }
            _state.push(invoice)
            return _state
        })
    }

    const handleInvoiceDelete = ( invoice) => {
        delete invoice["deleted"];
        delete invoice["foreign"];
        delete invoice["subseq"];
        delete invoice["invoiceRevBad"];
        delete invoice["buyerIdType"];
        delete invoice["despatchNoteReference"]
        delete invoice["requestForBidReference"]
        delete invoice["schemaIdentifier"]
        delete invoice["projectReference"]
        delete invoice["salesOrderReference"]
        delete invoice["contractReference"]
        delete invoice["buyerReference"]
        delete invoice["purchaseOrderReference"]
        delete invoice["receiptReference"]
        
        return mainAxios
            .post("apiEndpoint/saveOrUpdate", {
                object: "CustomInvoice",
                content: {
                    ...func.parseCustomInvoiceRequest(invoice),
                    action: invoiceActions[4],
                    status: invoiceStatuses[3],
                },
                nuis: company.nuis,
            })
    };

    const handleThermalPrint = (id) => {
        let index = invoices.findIndex((invoice) => invoice.id === id);
        if (index === currentInvoiceIndex) {
            printThermalInvoice();
        } else {
            setCurrentInvoiceIndex(
                invoices.findIndex((invoice) => invoice.id === id)
            );
        }
    };
    const firstUpdate = React.useRef(true);

    const printThermalInvoice = () => {
        const content = document.getElementById("thermalPrinterInvoice");
        const pri = document.getElementById("ifmcontentstoprint").contentWindow;
        pri.document.open();
        pri.document.write(
            `<html><style>@page{margin:0mm auto;margin-bottom:10mm;font-family: 'EB Garamond', serif;}</style>${content.innerHTML}</html>`
        );
        pri.document.close();
        pri.focus();
        pri.print();
    };
    React.useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        printThermalInvoice();
    }, [currentInvoiceIndex]);

    React.useEffect(() => {
        if (!(filters?.fromDate && filters?.toDate)) {
            return;
        }
        let endpoint = persistedData?.businessUnitCode
            ? "/endpoint/v2/reports/myinvoice/branch/aggregate"
            : "/endpoint/v2/reports/myinvoice/company/aggregate";
        if (isPos)
            endpoint = persistedData?.businessUnitCode
                ? "/endpoint/v2/reports/mypos/branch/aggregate"
                : "/endpoint/v2/reports/mypos/company/aggregate";

        mainAxios
            .post(endpoint, {
                object: "GetCustomInvoiceCashDepositStatisticsAnalytics",
                fromDate: moment(filters?.fromDate).format("YYYY-MM-DD"),
                toDate: moment(filters?.toDate).format("YYYY-MM-DD"),
                ...(filters?.params?.businessUnitCode
                    ? { params: { businessUnitCode: filters?.params?.businessUnitCode } }
                    : {}),
            })
            .then((res) => {
                if (res?.data?.status) {
                    let getStatistics = calculateStatistics(res.data.content);
                    setStatistics(getStatistics);
                }
            });
    }, [
        filters?.fromDate,
        filters?.toDate,
        filters?.params?.businessUnitCode,
        selectedCompany,
    ]);

    const calculateStatistics = (data) => {
        if (data?.length > 0) {
            const {
                id,
                tcrCode,
                businessUnitCode,
                actionFrom,
                company,
                recordDate,
                ...rest
            } = data[0];
            let stats = {};
            Object.keys(rest).forEach((key) => {
                stats[key] = data.reduce((sum, tcrStat) => sum + tcrStat[key], 0);
            });
            return stats;
        }
        return [];
    };

    const handleInvoiceCancel = (e, invoice) => {
        e.preventDefault();
        
        Swal.fire({
            title: t("invoice.cancelInvoice"),
            confirmButtonText: t(["company.yes"]),
            confirmButtonColor: "#d33",
            cancelButtonColor: "#007567",
            showCancelButton: true,
            cancelButtonText: t(["company.no"]),
        }).then((res) => {
            if (res.isConfirmed) {
                setLoading(true);
                const correctiveInvoice = JSON.parse(JSON.stringify(invoice));
                delete correctiveInvoice["id"];
                delete correctiveInvoice["invoiceHistorics"];
                delete correctiveInvoice["internalId"];
                delete correctiveInvoice["deleted"];
                delete correctiveInvoice["foreign"];
                delete correctiveInvoice["subseq"];
                delete correctiveInvoice["invoiceRevBad"];
                
                delete correctiveInvoice["despatchNoteReference"]
                delete correctiveInvoice["requestForBidReference"]
                delete correctiveInvoice["schemaIdentifier"]
                delete correctiveInvoice["projectReference"]
                delete correctiveInvoice["salesOrderReference"]
                delete correctiveInvoice["contractReference"]
                delete correctiveInvoice["buyerReference"]
                delete correctiveInvoice["purchaseOrderReference"]
                delete correctiveInvoice["receiptReference"]

                if (correctiveInvoice?.parties?.id) {
                    delete correctiveInvoice.parties.id;
                  }
                if(correctiveInvoice?.parties?.buyer?.id){
                    delete correctiveInvoice.parties.buyer.id;
                }  
                  
                if(correctiveInvoice?.parties?.seller?.id){
                    delete correctiveInvoice.parties.seller.id;
                }  
                  
                delete correctiveInvoice["buyerIdType"];
                
                // Reset subSequenceDelivType if it exists
                if (correctiveInvoice?.subSequenceDelivType != "" && correctiveInvoice?.subSequenceDelivType != null) {
                    correctiveInvoice.subSequenceDelivType = "";
                }


                const opCode=user?.userCompanyOperator?.find(
                    (uco) => parseInt(uco.company) === parseInt(selectedCompany)
                  )?.operator ?? correctiveInvoice.opCode

                correctiveInvoice.opCode = opCode
                if(correctiveInvoice?.discount?.id) delete correctiveInvoice.discount.id

                correctiveInvoice.attachments = correctiveInvoice.attachments.map(
                    (attachment) => {
                        const { id, ...rest } = attachment;
                        return rest;
                    }
                );
                correctiveInvoice.items = correctiveInvoice.items.map((item) => {
                    const { id, quantity, totalWithoutVat, totalWithVat, ...rest } = item;

                    return {
                        ...rest,
                        quantity: -1 * quantity,
                    };
                });

                correctiveInvoice.invoiceFees = correctiveInvoice?.invoiceFees?.map(fee => {
                    const { id,...restFee } = fee
                    return {...restFee,feeAmount:-1*fee.feeAmount}
                  }) ?? []

                if (correctiveInvoice?.paymentMethod?.length > 0) {
                    correctiveInvoice.paymentMethod = correctiveInvoice.paymentMethod.map(payment => {
                        return {
                            ...payment,
                            id:null,
                            paymentAmount: -1 * payment.paymentAmount
                        }
                    })
                }
                mainAxios
                    .post("/endpoint/v2.2/saveOrUpdate", {
                        object: "CustomInvoice",
                        content: {
                            ...func.parseCustomInvoiceRequest(correctiveInvoice),
                            issueDate: new Date(),
                            dueDate: new Date(),
                            action: invoiceActions[0],
                            status: invoiceStatuses[0],
                            iic: null,
                            fic: null,
                            eic: null,
                            recordDate: null,
                            recordUser: null,
                            number: "",
                            profileId: "P10",
                            type: "384",
                            correctiveInv: true,
                            correctiveInvType: "CORRECTIVE",
                            badDebtInv: false,
                            reverseCharge: false,
                            selfInvoice: false,
                            sumInv: false,
                            cisStatus: null,
                            cisError: null,
                            internalId: "",
                            iic_ref: correctiveInvoice.iic,
                            refInvIIC: correctiveInvoice.iic,
                            refInvIssueDateTime: invoice.issueDate,
                        },
                        nuis: company.nuis,
                    })
                    .then((res) => {
                        if (res?.data?.status === true) {
                            toast.success("Corrective Invoice Created!", {
                                containerId: "all_toast",
                            });
                            if (props?.isPos) {
                                history.push(
                                    "/pos-transactions/edit/" + res?.data?.content[0].id
                                );
                            } else {
                                history.push("/edit-invoice/" + res?.data?.content[0].id);
                            }
                        }
                        setLoading(false);
                    })
                    .catch(() => {
                        setLoading(false);
                    });
            }
        });
    };


    const userCompanyOperator = user?.userCompanyOperator?.map((userOpCode) => ({
        label: userOpCode.operator,
        value: userOpCode.operator,
    })) ?? [];

    const operatorCodes = [
        {
            label: t("invoice.selectOptions"),
            value: null,
        },
    ]
        .concat(
            [
                ...new Set(
                    company.branches
                        .reduce((acc, next) => acc.concat(next.tcrTypes), [])
                        .map((tcrType) => tcrType.operatorCode)
                ),
            ].map((operatorCode) => ({
                label: operatorCode,
                value: operatorCode,
            }))
        )
        .concat(userCompanyOperator);

    const invoiceTypeOptions = invoiceTypes
        .filter((invoice) => invoice.disabled == false)
        .map((type) => {
            return {
                ...type,
                label: t([type.label]),
            };
        });



    const [errors,setErrors]=useState([])

    const isRefreshStatus=useCallback((invoice)=>{
        let status = invoice?.status?.status;
        let resendStatuses = refreshStatuses?.filter(resendStatus=>resendStatus?.isActive==true)?.map(resendStatus=>resendStatus?.status)?? []
        let staticRefreshConditions=invoice?.einvoice && invoice?.cisStatus==="SUCCESS" && (!invoice?.eic || invoice.eic=="")
    
        return  (resendStatuses.includes(status)) || staticRefreshConditions
    },[refreshStatuses])

    const columns = isPos
        ? generatePosColumns(
            {
                showInvoicePdf,
                loadingPdf,
                toggleDeleteInvoice,
                handleInvoiceCancel,
                t,
                i18n,
                handleThermalPrint,
                isPos,
                invoiceTypeOptions,
                operatorCodes,
                invoices,
                isRefreshStatus
            }
        )
        : generateCustomInvoiceColumns(
            {
                showInvoicePdf,
                loadingPdf,
                toggleDeleteInvoice,
                handleInvoiceCancel,
                t,
                i18n,
                handleThermalPrint,
                isPos,
                invoiceTypeOptions,
                operatorCodes,
                setErrors,
                setLoading,
                handleDuplicateInvoice,
                spinLoading,
                invoices,
                isRefreshStatus,
                myinvoiceTypes
            }
        )

    const [selectedColumns, setSelectedColumns] = usePersistedState(
        columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})})),
        isPos?"posInvoiceColumnsPrime5":"customInvoiceColumnsPrime4"
    );


    const typeOptions = [
        {
            key: "isEinvoice",
            count: statistics?.onlyFiscalizationInvoicesNo,
            label: t("parameters.onlyFiscalization"),
            value: "false",
        },
        {
            key: "isEinvoice",
            count: statistics?.einvoiceInvoicesNo,
            label: t("invoice.eInvoicesOption"),
            value: "true",
        },
    ];

    const typeOptionsPos = [
        {
            key: "paymentMethodType",
            count: statistics?.cashInvoicesNo,
            label: "Cash",
            value: "cash",
        },

        {
            key: "paymentMethodType",
            count: statistics?.noncashInvoicesNo,
            label: "Non Cash",
            value: "noncash",
        },
    ];
    const statusOptions = [
        {
            key: "statusObj",
            count: statistics?.draftInvoicesNo,
            multiSelect: true,
            label: t("status.draft"),
            value: "7",
        },
        {
            key: "statusObj",
            count: statistics?.approvedInvoicesNo,
            multiSelect: true,
            label: t("status.approved"),
            value: "9",
        },
        {
            key: "statusObj",
            count: statistics?.errorInvoicesNo,
            multiSelect: true,
            label: "Error",
            value: "35",
        },
        {
            key: "statusObj",
            count: statistics?.retryInvoicesNo,
            multiSelect: true,
            label: "Retry",
            value: "36",
        },
        {
            key: "statusObj",
            count: statistics?.readyForApprovalInvoicesNo,
            multiSelect: true,
            label: t("status.readyForApproval"),
            value: "8",
        },
    ];

    const statusOptionsPos = [
        {
            key: "statusObj",
            multiSelect: true,
            label: t("status.draft"),
            count: statistics?.draftInvoicesNo,
            value: "7",
        },
        {
            key: "statusObj",
            count: statistics?.approvedInvoicesNo,
            multiSelect: true,
            label: t("status.approved"),
            value: "9",
        },
        {
            key: "statusObj",
            count: statistics?.retryInvoicesNo,
            multiSelect: true,
            label: "Retry",
            value: "36",
        },
        {
            key: "statusObj",
            count: statistics?.errorInvoicesNo,
            multiSelect: true,
            label: t("home.error"),
            value: "35",
        },
    ];

    const currencyOptions = [
        {
            key: "currency",
            count: statistics?.allCurrefncyInvoicesNo,
            multiSelect: true,
            label: "Lek",
            value: "ALL",
        },
        {
            key: "currency",
            count: statistics?.usdCurrencyInvoicesNo,
            multiSelect: true,
            label: "USD",
            value: "USD",
        },
        {
            key: "currency",
            count: statistics?.eurCurrencyInvoicesNo,
            multiSelect: true,
            label: "Euro",
            value: "EUR",
        },
    ];

    const currencyOptionsPos = [
        {
            key: "currency",
            count: statistics?.allCurrencyInvoicesNo,
            multiSelect: true,
            label: "Lek",
            value: "ALL",
        },
        {
            key: "currency",
            count: statistics?.usdCurrencyInvoicesNo,
            multiSelect: true,
            label: "USD",
            value: "USD",
        },
        {
            key: "currency",
            count: statistics?.eurCurrencyInvoicesNo,
            multiSelect: true,
            label: "Euro",
            value: "EUR",
        },
    ];

    const otherOptions = [
        {
            key: "isForeign",
            count: statistics?.foreignInvoicesNo,
            label: t("common.foreign"),
            value: "true",
        },
        {
            key: "type",
            multiSelect: true,
            count: statistics?.selfInvoicesNo,
            label: t("invoice.selfInvoice"),
            value: "389",
        },
        {
            key: "paymentMethodType",
            count: statistics?.cashInvoicesNo,
            label: "Cash",
            value: "cash",
        },
        {
            key: "isDeleted",
            count: statistics?.deletedInvoicesNo,
            label: t("invoice.showDeleted"),
            value: "true",
            isBoolean: true,
        },
    ];
    const otherOptionsPos = [
        {
            key: "isEinvoice",
            count: statistics?.onlyFiscalizationInvoicesNo,
            label: t("parameters.onlyFiscalization"),
            value: "false",
        },
        {
            key: "paymentMeans",
            count: statistics?.cardPaymentInvoicesNo,
            label: "Cards",
            value: "48",
        },
        {
            key: "isDeleted",
            count: statistics?.deletedInvoicesNo,
            label: t("invoice.showDeleted"),
            value: "true",
            isBoolean: true,
        },
    ];


    const userCanCreate = [1, 2, 4].includes(user.role.id);
    const userCanApprove = [1, 2, 15].includes(user.role.id);

    const filterStatisticCard=(typeOptions,props)=>globalFilterStatisticCard(typeOptions,{...props,handleParamsChange,getFilteredResults,user,filters})


    const expandedColumns = [
        {
            field: "",
            header: "",
            // style: { minWidth: 150, maxWidth: 150 },
        },
        {
            field: "invoiceAction",
            header: t(["home.actions"]),
            // style: { minWidth: 150, maxWidth: 150 },
            sortable: true,
            body: row => row?.invoiceAction?.action ?? ""
        },
        {
            field: "invoiceStatus",
            header: "Status",
            // style: { minWidth: 150, maxWidth: 150 },
            sortable: true,
            body: row => row?.invoiceStatus?.status ?? "",


        },
        {
            field: "cisStatus",
            header: "Cis Status",
            // style: { minWidth: 150, maxWidth: 150 },
            sortable: true,

        },
        {
            field: "recordDate",
            header: t(["home.date"]),
            body: (row) => {
                return row?.recordDate ? moment(row?.recordDate).format("DD/MM/YYYY HH:mm") : ""
            },
            // style: { minWidth: 150, maxWidth: 150 },


        },
        {
            field: "recordUser",
            header: t(["logs.user"]),
            // style: { minWidth: 150, maxWidth: 150 },

        },

    ];
    const rowExpansionTemplate = () => {
        const {
            fiscStatus,
            einvoiceStatus,
            ublInvoiceTypeCode,
            correctiveInvoiceType,
            number,
            type,
            status,
            cisStatus
        } = expandedData?.[0] ?? {};

        if (loadingExpandData) {
            return <div style={{ width: "100vw" }} className="d-flex justify-content-center">
                <Loader />
            </div>
        }
        return (
            <div style={{ width: "100vw" }} className="my-4 ">
                <div className="d-flex align-items-center mb-4">
                    <div style={{ fontSize: 16, fontWeight: 600, marginLeft: 55, marginRight: 20 }}>
                        Status
                    </div>
                    <InvoiceStatus
                        fiscStatus={fiscStatus}
                        einvoiceStatus={einvoiceStatus}
                        ublInvoiceTypeCode={type}
                        correctiveInvoiceType={correctiveInvoiceType}
                        isRefreshStatus={isRefreshStatus}
                    />
                </div>
                <div className="body p-0" >
                    <PrimeTable
                        value={expandedData?.[0]?.invoiceHistorics ?? []}
                        columns={expandedColumns}
                        showFilters={false}
                        paginator={false}
                        filterDisplay={false}
                        responsiveLayout="scroll"
                    />
                </div>
            </div>

        );
    };


    const swalAlert = async ({ title,text=t("invoice.responseDelay") }) => {

        return Swal.fire({
            title,
            text,
            confirmButtonText: t("company.yes"),
            confirmButtonColor: "#007567",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            cancelButtonText: t("company.no"),
        }).then((res) => {
            if (res.isConfirmed) {
                return true;
            } else {
                return false
            }
        });
    }


    const approveGroupedInvoices = ({ content }) => {
        setActionLoading(true)
        return mainAxios.post("/apiEndpoint/saveOrUpdate",
            {
                object: "GroupedCustomInvoice",
                content,
                nuis: company?.nuis,
            },
            { timeout: 180000 }
            ,
        ).then((res) => {
            setActionLoading(false)

            if (res.data.status) {
                setRefresh((refresh) => !refresh)
                setSelectedRows([])
                toast.success(t(["common.actionSuccessfully"]), {
                    containerId: "all_toast",
                })
            }
        })
            .catch(err => {
                setActionLoading(false)
                return false
            })
    }


    const headerButtonsRight = (
        <>
        {selectedDeleteRows?.length> 0 && <button className="btn btn-outline-danger mr-3"
            disabled={actionLoading}
            onClick={async () => {
                if (actionLoading) return;
                let res = await swalAlert({ title: t("invoice.deleteAllCustomInvoices"),text:null })
                if (res) {
                    const deletedInvoices = selectedDeleteRows ?? [];

                    const deletePromises = deletedInvoices.map((invoice) =>
                     handleInvoiceDelete(invoice)
                    );

                    try {
                        setActionLoading(true)
                        await Promise.all(deletePromises);
                        setActionLoading(false)
                        toast.success(t("invoice.allDraftsDeleted"), {
                            containerId: "all_toast",
                        });
                        setSelectedDeleteRows([])
                        setSelectedRows([])
                        setRefresh((refresh) => !refresh);
                    } catch (error) {
                        setSelectedRows([])
                        toast.error(t("toast.deletionFailed"), {
                            containerId: "all_toast",
                        });
                    }
                }
            }}>
            {t("invoice.deleteSelectedDrafts")}
        </button>}
         <div className="d-flex align-items-center">
            {userCanApprove && selectedRows.length > 0 && selectedDeleteRows.length==0 && <button className="btn btn-sm btn-outline-primary mr-3"
                disabled={actionLoading}
                onClick={async () => {
                    if (actionLoading) return;
                    let res = await swalAlert({
                                title: `${t("purchases.approveAllWarning")}<br/><span style='color:#00000;font-weight:bold;font-size:15px;'>${selectedRows.length} ${t("invoice.selected")}</span>`,
                                text: null,
                                html: true
                            })
                    if (res) {
                        const approvedInvoices = selectedRows ?? []
                        approveGroupedInvoices({ content: approvedInvoices })
                    }
                }}>
                {actionLoading ? <Loader size="xs" /> : t(["purchases.approveAll"])}
            </button>}
            {(selectedRows.length > 0 || selectedDeleteRows.length>0) && <button className="btn btn-sm btn-outline-primary mr-3"
                disabled={actionLoading}
                onClick={async () => {
                    if (actionLoading) return;
                        setSelectedDeleteRows([])
                        setSelectedRows([])
                }}>
                {actionLoading ? <Loader size="xs" /> : t("common.clear")}
            </button>}
        </div>
    </>
    )


    const onRowExpand = (e) => {
        setLoadingExpandData(true);
        setExpandedRows([e.data]);
        mainAxios
            .post("apiEndpoint/search", {
                object: "GetInvoice",
                params: {
                    ublId: e?.data?.number?.toString(),
                },
            })
            .then((res) => {
                if (res.data.status) {
                    const newData = res.data.content?.[0] ?? {}
                    setExpandedData([{
                        ...e.data,
                        ...newData
                    }]);
                    setLoadingExpandData(false);
                }
            });
    }

    const approveMultiInovicesBody=(invoice)=>{
        if(!userCanApprove || ![7, 8].includes(invoice?.status?.id)) return<></>
        return <Checkbox 
            onChange={
            (e) => {
                setSelectedRows((state)=>{
                    const _state=[...state]
                    const checkedValueIndex =_state.findIndex(sRow=>sRow==invoice?.id)
                    if(checkedValueIndex>=0) {
                        _state.splice(checkedValueIndex,1)
                        return _state
                    }
                    _state.push(invoice.id)
                    return _state
                })
            }
        } 
        checked={!!selectedRows.find(sRow=>sRow==invoice?.id)} 
        
        />
    }

    const approveMultiInovicesFilter=useMemo(()=>{
        if(!userCanApprove) return <></>
        const showFilter = invoices?.filter(invoice=>[7, 8].includes(invoice?.status?.id)) ?? []
        if(showFilter?.length==0) return <></> 
        return <Checkbox
            onChange={
                (e) => {
                    if(e.checked){
                        const _selectedRows=[]
                        invoices.forEach(invoice =>{
                            if([7, 8].includes(invoice?.status?.id)){
                                _selectedRows.push(invoice?.id)
                            }
                        })
                        setSelectedRows(_selectedRows)
                    }else{
                        setSelectedRows([])
                    }
                }
            }
            checked={selectedRows.length == showFilter?.length}
        />
    }, [invoices, selectedRows])


    const deleteMultiInvoicesFilter = useMemo(()=>{
        const showFilter = invoices?.filter(invoice=>[7].includes(invoice?.status?.id)) ?? []
        if(showFilter?.length==0) return <></> 
        return  (
        <div className="custom-danger-checkbox">
          <Checkbox
            onChange={
                (e) => {
                    if(e.checked){
                        setSelectedDeleteRows(showFilter)
                    }else{
                        setSelectedDeleteRows([])
                    }
                }
            }
            checked={selectedDeleteRows.length == showFilter?.length}
        />
        </div>
        )


    }, [invoices, selectedDeleteRows])

    const getNumberOfSelectedInvoices = () => {
            // If delete mode is active, count selectedDeleteRows, else count selectedRows
            return selectedDeleteRows?.length > 0 ? selectedDeleteRows.length : selectedRows.length;
        };

        // Component to display the number of selected invoices
        const numberOfSelectedInvoices = (
            <span  className="btn btn-sm btn-outline-primary">
                {getNumberOfSelectedInvoices() > 0 && (
                    <>
                        {t("invoice.selected")}: {getNumberOfSelectedInvoices()}
                    </>
                )}
            </span>
        );

    const deleteMultinvoicesBody=(invoice)=>{
        if(![7].includes(invoice?.status?.id)) return<></>
        return (
        <div className="custom-danger-checkbox">
         <Checkbox 
            onChange={
            (e) => {

                setSelectedDeleteRows((state)=>{
                    const _state=[...state]
                    const checkedValueIndex =_state.findIndex(sRow=>sRow.id==invoice?.id)
                    if(checkedValueIndex>=0) {
                        _state.splice(checkedValueIndex,1)
                        return _state
                    }
                    _state.push(invoice)
                    return _state
                })
            }
        } 
        checked={!!selectedDeleteRows.find(sRow=>sRow.id==invoice?.id)} 
        
        />
        </div>)
    }

    // Export dropdown for headerIcons
    const exportDropdown = (
        <ExportCsvMultiple
            data={invoicesForCSV}
            selectedColumns={selectedColumns}
            columns={columns}
            onClick={() => getFilteredResults({getInvoicesForCVS:true})}
            excludedColumns={["actions", "sendEmail", "print"]}
            callback={(invoice, formattedObject) => {
                formattedObject["Status"] = invoice.status.status;
                formattedObject["CIS Status"] = invoice.cisStatus || "";
            }}
            showAmount={true}
            asDropdown={true}
        />
    );

    return invoices ? (
        <>
            <div className="d-flex flex-wrap justify-content-between align-items-center my-1">
                <div className="left-header d-flex align-items-center  mb-3">
                    <h3 className="mb-0 p-0">
                        {isPos ? t("pos.posTransaction") : t("invoice.custom")}
                    </h3>
                    {[1].includes(user.role.id) && (
                        <div className="col ml-2">
                            <button
                                className="btn btn-sm btn-outline-primary btn-sm"
                                onClick={() => setOpenUploadInvoice(true)}
                            >
                                {t("invoice.upload")}
                            </button>
                        </div>
                    )}
                    <Dialog
                        header={t("invoice.upload")}
                        visible={openUploadInvoice}
                        onHide={() => setOpenUploadInvoice(false)}
                        style={{ width: "26vw" }}
                        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                    >

                        {[1].includes(user?.role?.id) && (<UploadInvoice
                            user={user}
                            selectedCompany={selectedCompany}
                        />)}
                    </Dialog>
                    {userCanCreate && (
                        <Link
                            to={isPos ? "/pos-transactions/create" : "/create-invoice"}
                            className="btn btn-sm btn-primary ml-3"
                        >
                            <FontAwesomeIcon icon={faPlus} className="mr-2" />
                            {t("navbar.create")}
                        </Link>
                    )}
                    <AlertCertificate />
                    <AlertSubscription />
                </div>
                <div className="d-flex align-items-center ml-auto">
                    <div className="mr-2">
                        <DateRange
                            fromDate={filters.fromDate}
                            toDate={filters.toDate}
                            onChange={(dates) => {
                                let fromDate = dates[0];
                                let toDate = dates[1];
                                if (fromDate && toDate) {
                                    getFilteredResults({data:{
                                        fromDate,
                                        toDate,
                                        params: { ...filters.params },
                                    }});
                                }
                                setFilters((filters) => ({
                                    ...filters,
                                    fromDate,
                                    toDate,
                                }));
                                setDates({ fromDate, toDate })
                                // setPersistedData({ ...persistedData, fromDate, toDate });
                            }}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{minWidth: "140px"}}>
                        <label className="align-items-center mr-2 mb-0">BU</label>
                        <Select
                            styles={selectStyle}
                            className="w-100"
                            options={businessUnitCodes}
                            value={
                                filters.params.businessUnitCode
                                    ? businessUnitCodes.find(
                                        (businessUnitCode) =>
                                            businessUnitCode.value === filters.params.businessUnitCode
                                    )
                                    : {
                                        label: t("invoice.businessUnitCode"),
                                        value: "",
                                    }
                            }
                            isSearchable={true}
                            onChange={(businessUnitCode) => {
                                handleParamsChange(
                                    null,
                                    "businessUnitCode",
                                    businessUnitCode.value
                                );
                                setPersistedData({
                                    ...persistedData,
                                    businessUnitCode: businessUnitCode.value,
                                });
                                getFilteredResults({data:{
                                    ...filters,
                                    params: {
                                        ...filters.params,
                                        businessUnitCode: businessUnitCode.value,
                                        tcrCode: null
                                    },
                                }});
                            }}
                            name="businessUnitCode"
                        />
                    </div>
                </div>

            </div>
            <div className="d-none">
                {invoices.length > 0 && (
                    <ThermalPrinterInvoiceContent
                        invoice={
                            currentInvoiceIndex ? invoices[currentInvoiceIndex] : invoices[0]
                        }
                    />
                )}
                <iframe id="ifmcontentstoprint"></iframe>
            </div>
            <div className="filter-cards-container d-none d-md-block">
                <div className="filter-cards-header">
                    <button
                        className={`filter-cards-toggle ${filtersCollapsed ? 'filter-cards-toggle--collapsed' : ''}`}
                        onClick={() => setFiltersCollapsed(!filtersCollapsed)}
                    >
                        <FontAwesomeIcon icon={faFilter} />
                        {filtersCollapsed ? (t("common.showFilters", "Show Filters")) : (t("common.hideFilters", "Hide Filters"))}
                        {filterCount > 0 && <span className="badge badge-primary ml-1">{filterCount}</span>}
                        <FontAwesomeIcon icon={faChevronUp} />
                    </button>
                </div>
                <div className={`filter-cards-row ${filtersCollapsed ? 'filter-cards-row--collapsed' : ''}`}>
                    {isPos ? (
                        <div className="filter-card-col">
                            {filterStatisticCard(typeOptionsPos, {
                                title: t("home.invoiceType"),
                                cardClasses: "stats-cols-1",
                            })}
                        </div>
                    ) : (
                        <div className="filter-card-col">
                            {filterStatisticCard(typeOptions, {
                                title: t("home.invoiceType"),
                                cardClasses: "stats-cols-1",
                            })}
                        </div>
                    )}
                    {isPos ? (
                        <div className="filter-card-col">
                            {filterStatisticCard(statusOptionsPos, { title: t("home.status"), cardClasses: "stats-cols-2" })}
                        </div>
                    ) : (
                        <div className="filter-card-col">
                            {filterStatisticCard(statusOptions, { title: t("home.status"), cardClasses: "stats-cols-2" })}
                        </div>
                    )}
                    {isPos ? (
                        <div className="filter-card-col">
                            {filterStatisticCard(currencyOptionsPos, {
                                title: t("invoice.currency"),
                                cardClasses: "stats-cols-1",
                            })}
                        </div>
                    ) : (
                        <div className="filter-card-col">
                            {filterStatisticCard(currencyOptions, {
                                title: t("invoice.currency"),
                                cardClasses: "stats-cols-1",
                            })}
                        </div>
                    )}
                    {isPos ? (
                        <div className="filter-card-col">
                            {filterStatisticCard(otherOptionsPos, {
                                title: t("invoice.other"),
                                cardClasses: "stats-cols-1",
                                type: "checkbox",
                            })}
                        </div>
                    ) : (
                        <div className="filter-card-col">
                            {filterStatisticCard(otherOptions, {
                                title: t("invoice.other"),
                                cardClasses: "stats-cols-2",
                                type: "checkbox",
                            })}
                        </div>
                    )}
                </div>
            </div>

            <div>
                    <PrimeTable
                        loading={loading}
                        showFilters={true}
                        filters={[filters, setFilters]}
                        defaultFilters={defaultFilters}
                        tableRows={[tableRows, setTableRows]}
                        persistedRowPerPage={[persistedRowPerPage, setPersistedRowPerPage]}
                        value={invoices ?? []}
                        gridKey={isPos ? "posInvoiceColumnsPrime5" : "customInvoiceColumnsPrime4"}
                        selectedColumns={[selectedColumns, setSelectedColumns]}
                        columns={columns}
                        dataKey="id"
                        onRemoteDataChange={(remoteData) => {
                            const updatedFilters = remoteData.filters ?? filters
                            const updatedTableData = remoteData.tableRows ?? tableRows
                            let { currentPage, rowsPerPage,sortCriteria } = updatedTableData
                            sortCriteria=sortCriteria?[sortCriteria]:[]
                            getFilteredResults({ data: updatedFilters, pageSize: rowsPerPage, page: currentPage,sortCriteria })
                          }}
                        expandedRows={expandedRows}
                        onRowExpand={onRowExpand}
                        onRowCollapse={() => { setExpandedRows([]); setExpandedData([]) }}
                        rowExpansionTemplate={rowExpansionTemplate}
                        headerButtonsRight={headerButtonsRight}
                        headerIcons={exportDropdown}
                        headerButtonsLeft={selectedRows.length > 0 && numberOfSelectedInvoices}
                        columnDeps={[fullCompany, invoices,spinLoading,loadingPdf]}//when should the colums should be rerendered,invoices length is needed because of thermal print
                    //needs an updated index to find the invoice
                        reorderableColumns={true}
                        defaultSortCriteria={defaultSortCriteria}
                        parseFilterValue={false}
                        mobileExpansionLabel={t("invoice.invoiceItems", "Invoice Items")}
                        mobileFilterContent={
                            <div className="filter-cards-row">
                                <div className="filter-card-col">
                                    {filterStatisticCard(isPos ? typeOptionsPos : typeOptions, {
                                        title: t("home.invoiceType"),
                                        cardClasses: "stats-cols-1",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(isPos ? statusOptionsPos : statusOptions, {
                                        title: t("home.status"),
                                        cardClasses: "stats-cols-2",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(isPos ? currencyOptionsPos : currencyOptions, {
                                        title: t("invoice.currency"),
                                        cardClasses: "stats-cols-1",
                                    })}
                                </div>
                                <div className="filter-card-col">
                                    {filterStatisticCard(isPos ? otherOptionsPos : otherOptions, {
                                        title: t("invoice.other"),
                                        cardClasses: isPos ? "stats-cols-1" : "stats-cols-2",
                                        type: "checkbox",
                                    })}
                                </div>
                            </div>
                        }
                    >
                        <Column
                         filter={true}
                         showFilterMenu={false}
                         showClearButton= {false}
                         filterElement={selectedDeleteRows?.length>0?deleteMultiInvoicesFilter:approveMultiInovicesFilter}
                         body={selectedDeleteRows?.length>0?deleteMultinvoicesBody :approveMultiInovicesBody}  
                        //  headerStyle={{ minWidth: '40px',maxWidth:"40px" }} 
                         style={{ minWidth: "10px",maxWidth:"40px" }}
                         
                         frozen />
                        <Column
                            expander={() => true}
                            style={{ minWidth: "70px",maxWidth:"70px" }}
                            header=""
                            field="expansion"
                            frozen={true}
                        />
                    </PrimeTable>
            </div>
            {pdfEmbed}
        </>
    ) : (
        <Loader />
    );
};

export default CustomInvoicesNew;
